import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * One answer option. While the quiz is being taken it behaves as a radio
 * button; once graded it is plain text under "Other Answers".
 *
 * Props:
 *   id         (string)   - Element ID.
 *   optionKey  (string)   - The answer's letter.
 *   optionText (string)   - The answer's text.
 *   isSelected (bool)     - Whether this is the learner's current choice.
 *   hideKey    (bool)     - Drops the "A." prefix, as True/False answers do.
 *   onSelect   (function) - Omit to render the read-only, graded version.
 */
export const OptionBox = ({ id, optionKey, optionText, isSelected, hideKey, onSelect }) => {
  const text = (
    <Typography className="optionText">
      {!hideKey && <span className="optionKey">{optionKey}.</span>}
      {optionText}
    </Typography>
  );

  if (!onSelect) {
    return (
      <Box className="optionBox" id={id}>
        {text}
      </Box>
    );
  }

  return (
    <Box
      className={`optionBox selectable ${isSelected ? 'selected' : ''}`}
      id={id}
      role="radio"
      aria-checked={isSelected}
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => {
        // Space would scroll the page, so stop it before selecting.
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      {text}
    </Box>
  );
};
